<script setup lang="ts">
import Notification from '@/components/notifications/Notification.vue';
import { useNotificationStore } from '@/stores/notification';

const notificationStore = useNotificationStore();

const emit = defineEmits(['close']);
</script>

<template>
    <v-expand-transition>
        <v-card class="notification-panel pa-0 shadow-lg">
            <v-row class="flex-column">
                <v-col>
                    <v-row class="py-3 px-7 justify-space-between align-center">
                        <h3 class="ma-0 pa-0 pt-1">Notificaties</h3>
                        <v-icon icon="close" class="hover-main rounded-xl" @click="emit('close')" />
                    </v-row>
                    <div class="py-3 px-7">
                        <p v-if="!notificationStore.employeeHasNotifications">Je hebt geen notificaties</p>
                        <Notification
                            v-else
                            v-for="notification in notificationStore.employeeNotifications"
                            :key="notification._id"
                            :notification="notification"
                        />
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-expand-transition>
</template>

<style scoped>
.notification-panel {
    border-radius: 10px 0 0 10px;
    z-index: 999;
    position: fixed;
    top: 80px;
    right: 0;
    background-color: var(--vt-c-white);
    max-height: 600px;
    overflow-y: auto;
    min-width: 400px;
}
</style>
